<template>

    <modal name="alert-modal"
            :width="450"
            class="modal-remove"
            >
            <img class="warning-icon" src="../assets/icons/warning.svg"/>
            <p>{{message}}</p>

           
            
          <cta type="button" @click="hideBox" text="Okay"  />

    </modal>


</template>

<script>
    export default {
        
        data : function(){       
            return {
                
                message: '',

            };
        },
        computed: {

           
        },
        watch :{

           


        },
        created : function(){
            this.$bus.$on('error_message', this.showErrorBox);
        },
        beforeDestroy() {
            this.$bus.$off('error_message', this.showErrorBox);
        },
        mounted : function ()
        {
        },
        destroyed () {
        },
        methods:{

            showErrorBox(message){
                this.$modal.show('alert-modal');
                this.message = message;
            },

            hideBox()
            {
                this.$modal.hide('alert-modal');
                setTimeout(()=>{ this.message = ''; }, 1000);
            }

        }
    }
</script>

<style lang="scss" >

.warning-icon{
    width:50px;
    margin:0 auto;
    display: block;
}

   



</style>